import React from 'react';
import { Badge } from '../ui/badge';

const STATUS_STYLES = {
  scheduled: { bg: 'bg-slate-100', text: 'text-slate-700', dot: 'bg-slate-400' },
  arrived: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-400' },
  checking_in: { bg: 'bg-teal-50', text: 'text-teal-700', dot: 'bg-teal-400' },
  ready: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  ready_for_nurse: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-400' },
  in_triage: { bg: 'bg-orange-50', text: 'text-orange-700', dot: 'bg-orange-400' },
  ready_for_provider: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'bg-blue-500' },
  in_visit: { bg: 'bg-indigo-50', text: 'text-indigo-700', dot: 'bg-indigo-400' },
  tasks_pending: { bg: 'bg-orange-50', text: 'text-orange-700', dot: 'bg-orange-400' },
  ready_for_checkout: { bg: 'bg-emerald-50', text: 'text-emerald-600', dot: 'bg-emerald-400' },
  completed: { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' },
  finalized: { bg: 'bg-teal-50', text: 'text-teal-700', dot: 'bg-teal-400' },
  cancelled: { bg: 'bg-red-50', text: 'text-red-600', dot: 'bg-red-400' },
  no_show: { bg: 'bg-red-50', text: 'text-red-600', dot: 'bg-red-400' },
  review_ready: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-400' },
  in_progress: { bg: 'bg-indigo-50', text: 'text-indigo-700', dot: 'bg-indigo-400' },
  draft: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' },
  pending_review: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-400' },
  reviewed: { bg: 'bg-teal-50', text: 'text-teal-700', dot: 'bg-teal-400' },
  exported: { bg: 'bg-gray-100', text: 'text-gray-600', dot: 'bg-gray-400' },
  archived: { bg: 'bg-gray-100', text: 'text-gray-500', dot: 'bg-gray-400' },
};

const LABELS = {
  scheduled: 'Scheduled', arrived: 'Arrived', checking_in: 'Checking In',
  ready: 'Ready for Nurse', ready_for_nurse: 'Ready for Nurse',
  in_triage: 'In Triage', ready_for_provider: 'Ready for Provider',
  in_visit: 'In Visit', tasks_pending: 'Tasks Pending',
  ready_for_checkout: 'Ready for Checkout',
  completed: 'Completed', finalized: 'Finalized',
  cancelled: 'Cancelled', no_show: 'No Show',
  review_ready: 'Review Ready', in_progress: 'In Progress', draft: 'Draft',
  pending_review: 'Pending Review', reviewed: 'Reviewed',
  exported: 'Exported', archived: 'Archived',
};

export default function StatusChip({ status, size = 'sm' }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.scheduled;
  const label = LABELS[status] || status?.replace(/_/g, ' ');

  return (
    <Badge
      variant="outline"
      className={`${style.bg} ${style.text} border-transparent gap-1.5 font-medium
        ${size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5'}`}
      data-testid="status-chip"
    >
      <span className={`w-1.5 h-1.5 rounded-full ${style.dot}`} />
      {label}
    </Badge>
  );
}
